"use strict";

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _inherits = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletLinkConnector = void 0;

var schemas_1 = require("@dcl/schemas");

var walletlink_connector_1 = require("@web3-react/walletlink-connector");

var configuration_1 = require("../configuration"); // Coinbase connector to connect a wallet with the Coinbase mobile wallet


var WalletLinkConnector = /*#__PURE__*/function (_walletlink_connector) {
  _inherits(WalletLinkConnector, _walletlink_connector);

  var _super = _createSuper(WalletLinkConnector);

  function WalletLinkConnector(chainId) {
    _classCallCheck(this, WalletLinkConnector);

    var config = configuration_1.getConfiguration()[schemas_1.ProviderType.WALLET_LINK];
    return _super.call(this, {
      url: config.urls[chainId],
      appName: config.appName,
      supportedChainIds: [chainId]
    });
  }

  return _createClass(WalletLinkConnector);
}(walletlink_connector_1.WalletLinkConnector);

exports.WalletLinkConnector = WalletLinkConnector;